import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from '../modules/auth/reducer';
import { userReducer } from '../modules/user/reducer';
import { appReducer } from '../modules/app/reducer';
import { catalogReducer } from '../modules/catalog/reducer';
import { ordersReducer } from '../modules/orders/reducer';
import { refundsReducer } from '../modules/refunds/reducer';
import { balanceReducer } from '../modules/wallet/reducer';
import { cartsReducer } from '../modules/cart/reducer';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  user: userReducer,
  balance: balanceReducer,
  catalog: catalogReducer,
  carts: cartsReducer,
  orders: ordersReducer,
  refunds: refundsReducer,
});

export default rootReducer;
